import { render } from "./UserBlock.vue?vue&type=template&id=2be7ef2e&scoped=true"
import script from "./UserBlock.vue?vue&type=script&lang=js"
export * from "./UserBlock.vue?vue&type=script&lang=js"

import "./UserBlock.vue?vue&type=style&index=0&id=2be7ef2e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be7ef2e"]])

export default __exports__